import { render, staticRenderFns } from "./jianxiForm.vue?vue&type=template&id=dc1f62b2&scoped=true"
import script from "./jianxiForm.vue?vue&type=script&lang=js"
export * from "./jianxiForm.vue?vue&type=script&lang=js"
import style0 from "./jianxiForm.vue?vue&type=style&index=0&id=dc1f62b2&prod&scoped=true&lang=less"
import style1 from "./jianxiForm.vue?vue&type=style&index=1&id=dc1f62b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1f62b2",
  null
  
)

export default component.exports